import { render } from "./MobileAboutUs.vue?vue&type=template&id=0b0df5c8&scoped=true"
import script from "./MobileAboutUs.vue?vue&type=script&lang=js"
export * from "./MobileAboutUs.vue?vue&type=script&lang=js"

import "./MobileAboutUs.vue?vue&type=style&index=0&id=0b0df5c8&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_9acfb15ce118456a03f39fb117bb0076/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0df5c8"]])

export default __exports__